<template>
  <v-select
    v-model="selectedPlace"
    placeholder="Start typing to search"
    label="description"
    :options="places"
    :reduce="opt => opt.place_id"
    class="mb-2"
    @search="fetchPlaces"
    @input="onSelectedPlace"
  />
</template>

<script>
import vSelect from 'vue-select'
import { debounce } from 'lodash'
import { ref } from '@vue/composition-api'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import tripsStore from '@/views/trips/store'

export default {
  components: {
    vSelect,
  },
  setup(_, ctx) {
    useRegisterStoreModule('trips', tripsStore)
    const selectedPlace = ref(null)
    const setMarkerLoading = ref(false)
    const selectedLat = ref(null)
    const selectedLng = ref(null)
    const places = ref([])
    const fetchPlaces = debounce(async (search, loading) => {
      if (!search) return
      loading(true)
      const res = await ctx.root.$store.dispatch('trips/searchPlaces', {
        text: search,
      })
      places.value = res.data.data.places
      loading(false)
    }, 1000)
    const onSelectedPlace = async () => {
      setMarkerLoading.value = true
      const res = await ctx.root.$store.dispatch('trips/getPlaceLatLong', {
        placeId: selectedPlace.value,
      })
      const { location } = res.data.data.results.at(0).geometry
      selectedLat.value = location.lat
      selectedLng.value = location.lng
      ctx.emit('coordinates-caught', {
        lat: location.lat,
        lng: location.lng,
      })
      setMarkerLoading.value = false
    }

    return {
      onSelectedPlace,
      fetchPlaces,
      places,
      setMarkerLoading,
      selectedPlace,
      selectedLat,
      selectedLng,
    }
  },
}
</script>
